import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./supabase.types.js";

/**
 * Admin Supabase client used by the /admin/* surface.
 *
 * Distinct from `supabase-browser` which intentionally runs without a session
 * (anon key, public catalog reads only). Here we keep a session in
 * localStorage and auto-refresh tokens so admins stay signed in across
 * reloads. Anon-key reads are still RLS-gated; admin policies use is_admin()
 * which checks auth.email() against the admin_users allowlist.
 */
let cached: SupabaseClient<Database> | null = null;

export function getAdminClient(): SupabaseClient<Database> {
  if (cached) return cached;

  const url = import.meta.env.VITE_SUPABASE_URL?.trim();
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
  if (!url || !anonKey) {
    throw new Error(
      "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Set them in Vercel and redeploy."
    );
  }

  cached = createClient<Database>(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: "hap-admin-auth",
    },
  });
  return cached;
}
